var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.75H2.5C2.16859 18.7497 1.85085 18.6178 1.6165 18.3835C1.38216 18.1492 1.25035 17.8314 1.25 17.5V12.5C1.25035 12.1686 1.38216 11.8508 1.6165 11.6165C1.85085 11.3822 2.16859 11.2503 2.5 11.25H17.5C17.8314 11.2503 18.1492 11.3822 18.3835 11.6165C18.6178 11.8508 18.7497 12.1686 18.75 12.5V17.5C18.7497 17.8314 18.6178 18.1492 18.3835 18.3835C18.1492 18.6178 17.8314 18.7497 17.5 18.75ZM2.5 12.5H2.49906L2.5 17.5H17.5V12.5H2.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.75H2.5C2.16859 8.74965 1.85085 8.61785 1.6165 8.3835C1.38216 8.14915 1.25035 7.83141 1.25 7.5V2.5C1.25035 2.16859 1.38216 1.85085 1.6165 1.6165C1.85085 1.38216 2.16859 1.25035 2.5 1.25H17.5C17.8314 1.25035 18.1492 1.38216 18.3835 1.6165C18.6178 1.85085 18.7497 2.16859 18.75 2.5V7.5C18.7497 7.83141 18.6178 8.14915 18.3835 8.3835C18.1492 8.61785 17.8314 8.74965 17.5 8.75ZM2.5 2.5H2.49906L2.5 7.5H17.5V2.5H2.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalView);
export default __webpack_public_path__ + "static/media/vertical_view.90d54cbe15cc9cb644ae66574db8952c.svg";
export { ForwardRef as ReactComponent };